module.exports = __webpack_public_path__ + "static/img/leLogoTwo.7ae2bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/leBaiBaiImg/leLogoTwo.png
// module id = b6jc
// module chunks = 1